import * as React from 'react';
import { useTheme } from '../theme';
import { infoIcon } from './Icons';
import MediaQuery from '../MediaQuery/MediaQuery';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

interface Props {
	warnings?: string[];
	className?: string;
	textClassName?: string;
	iconClassName?: string;
	iconTextClassName?: string;
	contentClassName?: string;
}

const Warnings: React.FunctionComponent<Props> = ({
	warnings,
	children,
	className,
	textClassName,
	iconClassName,
	iconTextClassName,
	contentClassName
}) => {
	const css = useTheme('Warnings').WarningsStyles;
	const { t } = useTranslation('Warnings');

	return (
		<div className={cn(css.wrapper, className)}>
			{children ? (
				<div className={cn(css.warning, contentClassName)}>
					<div className={cn(css.warning__icon, iconClassName)}>
						{infoIcon}
						<MediaQuery maxWidth={'mobile'}>
							<span className={cn(css.icon__text, iconTextClassName)}>{t('Clarification')}</span>
						</MediaQuery>
					</div>
					<div className={cn(css.warning__text, textClassName)}>{children}</div>
				</div>
			) : (
				warnings.map((warning, index) => (
					<div key={index} className={cn(css.warning, contentClassName)}>
						<div className={cn(css.warning__icon, iconClassName)}>
							{infoIcon}
							<MediaQuery maxWidth={'mobile'}>
								<span className={cn(css.icon__text, iconTextClassName)}>{t('Clarification')}</span>
							</MediaQuery>
						</div>
						<div className={cn(css.warning__text, textClassName)}>{warning}</div>
					</div>
				))
			)}
		</div>
	);
};

export default Warnings;
